export const STRAP_CONFIG_TTL = 60 * 60 * 1000; // 1 hour

function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem("handdn_device_id");
    if (!deviceId) {
        deviceId = "dev_" + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
        localStorage.setItem("handdn_device_id", deviceId);
    }
    return deviceId;
}

export function getCartStorageKey() {
    return `handdn_local_cart_areas_${getOrCreateDeviceId()}`;
}

export function getStrapConfigKey() {
    return `handdn_strap_config_${getOrCreateDeviceId()}`;
}

export function loadSavedStrapConfig() {
    try {
        const raw = localStorage.getItem(getStrapConfigKey());
        if (!raw) return null;
        const { ts, selections, config } = JSON.parse(raw);
        if (Date.now() - ts > STRAP_CONFIG_TTL) {
            localStorage.removeItem(getStrapConfigKey());
            return null;
        }
        return { selections: selections || {}, config: config || null };
    } catch { return null; }
}
